// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-details__content-wrapper {
	background-color: white;
	min-height: calc(100vh - 1px);
	display: flex;
	flex-direction: column;
	padding: 22px 24px 24px 0;
	gap: 24px;
}

.product-details__content {
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 24px;
	padding: 24px;
	background-color: #f2f2f2;
	border-radius: 10px;
}

.product-details__back {
	width: 45px;
	height: 45px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f2f2f2;
	cursor: pointer;
}

.product-name-title {
	color: #1a4074;
}

.product-details-carousel .active::before {
	background: transparent !important;
}

.product-details-textarea {
	background-color: white !important;
	resize: none;
	height: 150px;
}

.product-details-status-block {
	display: flex;
	gap: 16px;
	padding: 24px;
	border-radius: 10px;
	background-color: #f4c3cb;
	align-items: center;
}

.product-details-status-block-text {
	display: flex;
	flex-direction: column;
	gap: 4px;
	font-size: 16px;
	line-height: 24px;
	color: #191919;
}

.product-details-status-block.pending-synchronization {
	background-color: #e6f0f7;
}

.product-details-status-block.integration_missing {
	background-color: #fceba1;
}

.product-details__content-header {
	display: flex;
	align-items: start;
	justify-content: space-between;
	gap: 24px;
}

.product-details__content-title {
	font-size: 24px;
	line-height: 30px;
	font-weight: 600;
	color: #191919;
}

.product-details__images-list {
	display: flex;
	align-items: center;
	gap: 16px;
	flex-wrap: nowrap;
	height: 346px;
	overflow-y: auto;
	justify-content: flex-start;
}

.product-details__images-list img {
	height: 100%;
	border-radius: 4px;
}

.product-details__content-info {
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 24px;
	background-color: white;
	border-radius: 10px;
}

.product-details__content-info-title {
	font-size: 24px;
	line-height: 30px;
	font-weight: 500;
	color: #191919;
}

.default-input-label {
	font-size: 14px;
	line-height: 17px;
	color: #666666;
}

.edit-images__wrapper {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
	gap: 16px;
	width: 100%;
}

.edit-images__image {
	border: 1px solid #e6e6e6;
	border-radius: 4px;
	overflow: hidden;
	object-fit: cover;
	aspect-ratio: 1 / 1;
	width: 100%;
	-webkit-user-select: none;
	        user-select: none;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: 0.2s;
}

.edit-images__image img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.edit-images__image .remove-icon {
	display: none;
}

.edit-images__image:hover .remove-icon {
	display: block;
}

.edit-images__image:hover img {
	display: none;
}

.edit-images__image.upload {
	border-style: dashed;
	border-dash-array: 4;
	transition: 0.2s;
}

.edit-images__image.upload:hover {
	background-color: #f2f2f2;
	transition: 0.2s;
	border-style: solid;
}

.edit-images__image:hover {
	background-color: #f2f2f2;
	transition: 0.4s;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/Dashboard/ProductDetails/ProductDetails.css"],"names":[],"mappings":"AAAA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,aAAa;CACb,sBAAsB;CACtB,yBAAyB;CACzB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,WAAW;CACX,SAAS;CACT,aAAa;CACb,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;CAClC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,aAAa;CACb,SAAS;CACT,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,QAAQ;CACR,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,iBAAiB;CACjB,aAAa;CACb,gBAAgB;CAChB,2BAA2B;AAC5B;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,4DAA4D;CAC5D,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,mBAAmB;CACnB,WAAW;CACX,yBAAiB;SAAjB,iBAAiB;CACjB,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;AACjB","sourcesContent":[".product-details__content-wrapper {\n\tbackground-color: white;\n\tmin-height: calc(100vh - 1px);\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 22px 24px 24px 0;\n\tgap: 24px;\n}\n\n.product-details__content {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tgap: 24px;\n\tpadding: 24px;\n\tbackground-color: #f2f2f2;\n\tborder-radius: 10px;\n}\n\n.product-details__back {\n\twidth: 45px;\n\theight: 45px;\n\tborder-radius: 8px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: #f2f2f2;\n\tcursor: pointer;\n}\n\n.product-name-title {\n\tcolor: #1a4074;\n}\n\n.product-details-carousel .active::before {\n\tbackground: transparent !important;\n}\n\n.product-details-textarea {\n\tbackground-color: white !important;\n\tresize: none;\n\theight: 150px;\n}\n\n.product-details-status-block {\n\tdisplay: flex;\n\tgap: 16px;\n\tpadding: 24px;\n\tborder-radius: 10px;\n\tbackground-color: #f4c3cb;\n\talign-items: center;\n}\n\n.product-details-status-block-text {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 4px;\n\tfont-size: 16px;\n\tline-height: 24px;\n\tcolor: #191919;\n}\n\n.product-details-status-block.pending-synchronization {\n\tbackground-color: #e6f0f7;\n}\n\n.product-details-status-block.integration_missing {\n\tbackground-color: #fceba1;\n}\n\n.product-details__content-header {\n\tdisplay: flex;\n\talign-items: start;\n\tjustify-content: space-between;\n\tgap: 24px;\n}\n\n.product-details__content-title {\n\tfont-size: 24px;\n\tline-height: 30px;\n\tfont-weight: 600;\n\tcolor: #191919;\n}\n\n.product-details__images-list {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 16px;\n\tflex-wrap: nowrap;\n\theight: 346px;\n\toverflow-y: auto;\n\tjustify-content: flex-start;\n}\n\n.product-details__images-list img {\n\theight: 100%;\n\tborder-radius: 4px;\n}\n\n.product-details__content-info {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n\tpadding: 24px;\n\tbackground-color: white;\n\tborder-radius: 10px;\n}\n\n.product-details__content-info-title {\n\tfont-size: 24px;\n\tline-height: 30px;\n\tfont-weight: 500;\n\tcolor: #191919;\n}\n\n.default-input-label {\n\tfont-size: 14px;\n\tline-height: 17px;\n\tcolor: #666666;\n}\n\n.edit-images__wrapper {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n\tgap: 16px;\n\twidth: 100%;\n}\n\n.edit-images__image {\n\tborder: 1px solid #e6e6e6;\n\tborder-radius: 4px;\n\toverflow: hidden;\n\tobject-fit: cover;\n\taspect-ratio: 1 / 1;\n\twidth: 100%;\n\tuser-select: none;\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttransition: 0.2s;\n}\n\n.edit-images__image img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.edit-images__image .remove-icon {\n\tdisplay: none;\n}\n\n.edit-images__image:hover .remove-icon {\n\tdisplay: block;\n}\n\n.edit-images__image:hover img {\n\tdisplay: none;\n}\n\n.edit-images__image.upload {\n\tborder-style: dashed;\n\tborder-dash-array: 4;\n\ttransition: 0.2s;\n}\n\n.edit-images__image.upload:hover {\n\tbackground-color: #f2f2f2;\n\ttransition: 0.2s;\n\tborder-style: solid;\n}\n\n.edit-images__image:hover {\n\tbackground-color: #f2f2f2;\n\ttransition: 0.4s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
